import { Theme } from '@mui/material';

export const riskLevelMap = (theme: Theme) => ({
  1: theme.palette.success.main,
  2: theme.palette.success.main,
  3: theme.palette.success.main,
  4: theme.palette.info.main,
  5: theme.palette.info.main,
  6: theme.palette.warning.main,
  7: theme.palette.warning.main,
  8: theme.palette.error.main,
  9: theme.palette.error.main,
  10: theme.palette.error.main,
});
